
import { Component, Vue } from "vue-property-decorator";
import axios, { AxiosError, AxiosResponse } from "axios";
import { cloneDeep } from "lodash";
import ArcgisAuthenticate from "../utils/ArcgisAuthenticate";
// import "./../../node_modules/bulma/css/bulma.css";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { pushCoords } from "../utils/Routing";
const arcgisAuthenticate = new ArcgisAuthenticate();

@Component
export default class Home extends Vue {
  public environment = process.env.VUE_APP_ENV || "qas";
  public validationError = "Noti no, GEO code or <lat>,<long>";
  public defaultLocationList = cloneDeep(Vue.prototype.startingLocations);
  public defaultLocationLabel = this.defaultLocationList[0].label;
  private dropdown_active = false;
  $refs!: {
    input: HTMLInputElement;
    validation: HTMLLabelElement;
    fromHere: HTMLInputElement;
    fromDepot: HTMLInputElement;
    assetOnly: HTMLInputElement;
  };

  public locationSelection = (location: Record<string, string>): string => {
    const checkbox: HTMLFormElement = (document as Document).getElementById(
      "fromDepot"
    ) as HTMLFormElement;
    checkbox.checked = true;
    return location.label;
  };

  private focusInput = () => {
    this.$refs.input.focus();
  };

  private handleError(err: AxiosError) {
    let errMsg = "";
    if ([498, 499].includes((err.response as AxiosResponse).status)) {
      try {
        arcgisAuthenticate.reauthenticate();
      } catch (ex) {
        errMsg = "Failed getting access tokens for the ArcGIS services";
      }
    } else if (err.message.indexOf("timeout") != -1) {
      errMsg = "Timeout getting authorisation from WorkMate back-end";
    } else if (
      typeof (err.response as AxiosResponse).data == "string" &&
      (err.response as AxiosResponse).data.indexOf("ECONNREFUSED")
    ) {
      errMsg = "WorkMate back-end is currently not responding or not available";
    } else if (
      typeof (err.response as AxiosResponse).data == "object" &&
      "error" in (err.response as AxiosResponse).data
    ) {
      errMsg = (err.response as AxiosResponse).data.error;
    } else {
      errMsg = err.message;
    }
    console.error(errMsg);
    this.validationError = errMsg;
    this.$refs.validation.setAttribute("class", "show");
  }

  public onEnter() {
    // set starting coordinates as currenty location or selected location
    const fromDepot: boolean = this.$refs.fromDepot.checked;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let origin: any | string | null = null;
    console.log("this.defaultLocationLabel", this.defaultLocationLabel);
    console.log("this.defaultLocationList", this.defaultLocationList);
    if (fromDepot) {
      try {
        origin = this.defaultLocationList
          .filter((el: Record<string, string | number[]>) => {
            return el.label == this.defaultLocationLabel;
          })
          .pop();
        origin = origin.abbr;
      } catch (e) {
        console.log("e", e);
      }
    }
    const assetOnly: boolean = this.$refs.assetOnly.checked;

    // handle input text
    const floatRegex = "(-?\\d+(?:\\.\\d+)?)";
    const geoCodeRegex = new RegExp(
      `^GEO:${floatRegex};${floatRegex}(?:;\\d)?$`
    );
    const latLongRegex = new RegExp(`^${floatRegex}\\s*,\\s*${floatRegex}$`);
    const notiNoRegex = new RegExp("^(\\d{7,8})$");
    const workOrderNoRegex = new RegExp("^(\\d{9,})$");
    const param: string = this.$refs.input.value;
    let lat: string | null = null;
    let long: string | null = null;
    let noti: string | null = null;
    let workOrder: string | null = null;

    // input against various input types
    // match with Geocode
    let matches: string[] | null = param.match(geoCodeRegex);
    if (matches) {
      lat = matches[2];
      long = matches[1];
    } else {
      // match with lat/long
      matches = param.match(latLongRegex);
      if (matches) {
        lat = matches[1];
        long = matches[2];
      } else {
        // match with lat/long
        matches = param.match(notiNoRegex);
        if (matches) {
          noti = matches[1];
        } else {
          matches = param.match(workOrderNoRegex);
          if (matches) {
            workOrder = matches[1];
          }
        }
      }
    }

    if (lat && long) {
      pushCoords(`${lat},${long}`, origin, assetOnly);
      this.$router.go(0);
    } else if (noti) {
      pushCoords(null, origin, assetOnly, noti);
      this.$router.go(0);
    } else if (workOrder) {
      pushCoords(null, origin, assetOnly, null, workOrder);
      this.$router.go(0);
    }
    // else show error
    else {
      this.$refs.validation.setAttribute("class", "show");
    }
  }

  mounted() {
    // sets focus to the search text when landing on the page
    this.focusInput();
    // get auth code from portal authorize end-point, if from a redirect callback
    const code = this.$route.query.code;
    // if we have an auth code, remove in from the url and update url
    if (code) {
      this.$router.replace({ query: undefined });
    }
    // authenticate
    arcgisAuthenticate.authenticate(
      code as string,
      window.location.origin + this.$route.fullPath
    );
    // if no secure cookie, set the cookie from the back-end using auth code
    const authCode = arcgisAuthenticate.getItem("auth_code");
    const redirectUri = arcgisAuthenticate.getItem("redirect_uri");
    if (
      !arcgisAuthenticate.hasCookie("arcgis_enterprise_auth") &&
      authCode &&
      redirectUri
    ) {
      axios
        .get(`/api/authorise-only?code=${authCode}&redirect_uri=${redirectUri}`)
        .catch(err => {
          this.handleError(err);
        });
    }
  }
}
